import moment from "moment";
class cards {
  constructor(empId, cardId, perfId, from, to, card) {
    this.empId = empId;
    this.cardId = cardId;
    this.perfId = perfId;
    this.from = moment(from).utc().format("DD-MM-YYYY");
    this.to =
      to === null || to === undefined
        ? " "
        : moment.utc(to).format("DD-MM-YYYY");
    this.id = cardId + from;
    this.card = card?.trim();
    this.name = card?.trim();
  }
  static fromJson({ EmpId, TarjId, PerfId, FecDesde, FecHasta, Tarjeta }) {
    return new cards(EmpId, TarjId, PerfId, FecDesde, FecHasta, Tarjeta);
  }
}

export default cards;
